import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useTenantConfig } from '../../context/TenantConfigContext'
import './HeroCentered.css'

function formatHeroPrice(vehicle) {
  if (vehicle?.priceLabel) return vehicle.priceLabel
  if (vehicle?.price != null) {
    return `US$ ${Number(vehicle.price).toLocaleString('es-UY', { maximumFractionDigits: 0 })}`
  }
  return ''
}

function HeroCentered() {
  const { t } = useTranslation()
  const { config, vehicles } = useTenantConfig()
  const coverImage = config?.portraitImage || null
  const showcase = vehicles[0] || null
  const heroDescription =
    (config?.brand?.description && String(config.brand.description).trim()) || t('hero.description')
  const heroTitle =
    (config?.brand?.heroTitle && String(config.brand.heroTitle).trim()) || t('hero.title')
  const vehicleCount = vehicles.length
  const contactPhone = config?.contact?.phone || ''
  const contactTel = contactPhone.replace(/\D/g, '')
  const whatsapp = config?.contact?.whatsapp || contactPhone
  const whatsappTel = String(whatsapp || '').replace(/\D/g, '')

  return (
    <section className="hero hero--banner">
      <div className="hero__media">
        {coverImage ? (
          <img src={coverImage} alt="" className="hero__img" />
        ) : (
          <div className="hero__img hero__img--fallback" aria-hidden />
        )}
        <div className="hero__shade" aria-hidden />
      </div>

      <div className="hero__panel">
        <div className="hero__layout">
          <div className="hero__card hero__reveal">
            <span className="hero__accent" aria-hidden />
            <h1 className="hero__title">{heroTitle}</h1>
            <p className="hero__description">{heroDescription}</p>

            {vehicleCount > 0 ? (
              <div className="hero__tags">
                <span className="hero__tag">{t('home.hero.stock', { count: vehicleCount })}</span>
                <span className="hero__tag">{t('home.benefits.financing.title')}</span>
              </div>
            ) : null}

            <div className="hero__actions">
              <Link to="/vehiculos" className="hero__btn hero__btn--primary">
                {t('hero.viewVehicles')}
                <svg className="hero__btn-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden>
                  <path
                    d="M5 12h14M13 6l6 6-6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
              {whatsappTel ? (
                <a
                  href={`https://wa.me/${whatsappTel}`}
                  target="_blank"
                  rel="noreferrer"
                  className="hero__btn hero__btn--outline"
                >
                  {t('hero.contact')}
                </a>
              ) : contactTel ? (
                <a href={`tel:${contactTel}`} className="hero__btn hero__btn--outline">
                  {t('hero.contact')}
                </a>
              ) : (
                <a href="#contacto" className="hero__btn hero__btn--outline">
                  {t('hero.contact')}
                </a>
              )}
            </div>
          </div>

          {showcase ? (
            <Link to={`/vehiculos/${showcase.id}`} className="hero__showcase hero__reveal hero__reveal--delay">
              <div className="hero__showcase-media">
                {showcase.image ? (
                  <img src={showcase.image} alt="" className="hero__showcase-img" />
                ) : (
                  <div className="hero__showcase-placeholder" />
                )}
                <span className="hero__showcase-badge">{t('home.featured.eyebrow')}</span>
              </div>
              <div className="hero__showcase-body">
                <p className="hero__showcase-title">{showcase.titleLine1 || showcase.title}</p>
                {showcase.titleLine2 ? (
                  <p className="hero__showcase-sub">{showcase.titleLine2}</p>
                ) : null}
                <p className="hero__showcase-price">{formatHeroPrice(showcase)}</p>
                <span className="hero__showcase-cta">
                  {t('listings.card.viewDetail')} →
                </span>
              </div>
            </Link>
          ) : null}
        </div>
      </div>

      {vehicleCount > 0 ? (
        <a href="#home-featured" className="hero__scroll" aria-label={t('home.scrollHint')}>
          <span className="hero__scroll-line" />
        </a>
      ) : null}

      <div className="hero__curve" aria-hidden>
        <svg viewBox="0 0 1440 64" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 32C360 64 720 0 1080 32C1260 48 1380 40 1440 36V64H0V32Z" />
        </svg>
      </div>
    </section>
  )
}

export default HeroCentered
